<script>
  import { createEventDispatcher, onMount } from "svelte";
  //import { PreferenceSchoolBoroughs } from "../application/store.js";
  import { User } from "../../store.js";
  import Select from "../HTMLElements/Select.svelte";
  import wrappedFetch from "../../wrappedFetch.js";
  import SearchSelect from "../HTMLElements/SearchSelect.svelte";
  const dispatch = new createEventDispatcher();

  export let gender;
  export let phaseID;
  export let laid;
  export let isMultipleApplication = false;
  export let selectedSchoolIds=[];
  let laList = [];
  let availableSchools = [];
  let error = false;
  let selectedSchoolId;
  let placeholder = "--- Please select ---";
  let schoolPlaceholder = "--- Please select a LA ---"
  let laIdSelected = laid;
  let disabledButton = schoolPlaceholder === '--- Please select a LA ---'

  export let showSchoolsList = false;
  onMount(async () => {    
    if (!isMultipleApplication) {
      await wrappedFetch(`borough/getavailboroughsforpreference?phase=${phaseID}&gender=${gender}&parent_id=${$User.id}`)
        .then(res => res.json())
        .then(result => {          
          result.forEach((data, key) => {
            result[key]["label"] = data.name;
          });
          laList = result;
          laIdSelected = laid;
          showSchoolsList = true;
        });
    }
    showSchoolsList = true;
    
    selectSchools();
  });

  const selectSchools = async () => {
    selectedSchoolId=null;
    availableSchools=[];     
    availableSchools = await wrappedFetch(
      `preferences/GetAvailableSchoolsforpreference?laid=${laIdSelected}&phase=${phaseID}&gender=${gender}&parent_id=${$User.id}`
    ).then(result => result.json());  
    //remove selected schools from list     
       if(selectedSchoolIds.length > 0)
        availableSchools= availableSchools.filter(s => { if(!selectedSchoolIds.includes(s.id)) return s;});  

    availableSchools.forEach((data,key) => {availableSchools[key]["label"] = data.name;})  
    if(availableSchools.length > 0 ){
      schoolPlaceholder = "--- Please select ---";
      disabledButton = true
    }
      
    dispatch("laChange");
  };

  const onAddSchool = () => {
    error = false;
    if(selectedSchoolId)
      dispatch('addSchool', selectedSchoolId);
      else 
      error = true;
  };
 
</script>

{#if !isMultipleApplication}
  <div class="field">
    <div class="">
      <label for="" class="label">Select a Local Authority</label>
      <div>
        <Select
          items={laList}
          bind:selectedValue={laIdSelected}
          placeholder="--- Please select ---"
          label="a Local Authority"
          on:change={selectSchools}
          selectedValueText="id" />
      </div>
    </div>
  </div>
{/if}
{#if laid != ''} 
  <div class="field">
    <div class="">
      <label for="" class="label">Select a school</label>
      <div>
        <SearchSelect
          itemList={availableSchools}
          placeholder={schoolPlaceholder}
          disabled={disabledButton}
          bind:showDropdown={showSchoolsList} 
          bind:selected={selectedSchoolId} 
          on:change={onAddSchool} />
      </div>
    </div>
  </div> 
  {#if error}
      <div class="notification is-invalid">
        <p class="help" style="margin-bottom:0px">Please select a school</p>
      </div>
  {/if}
{/if}
